import {
    Center, Container, Flex, Heading, SimpleGrid,
    Text,
} from '@chakra-ui/react';
import { DiLogo } from '../components/di-logo';

export function ImageContentLayout({
    header = 'Compliance made simpler.',
    description = 'Welcome to your new and improved compliance portal, where safer homes live.',
    children,
}: {
    children: React.ReactNode;
    header?: string;
    description?: string;
}) {
    return (
        <Flex minH="100vh" direction={['column', null, null, 'row']}>
            <SimpleGrid
                display="grid"
                columns={1}
                maxW={[null, null, null, '50%']}
                minW={[null, null, null, '50%']}
                bg="secondary.500"
            >
                <Flex
                    flexDir="column"
                    gridColumn="1"
                    gridRow="1"
                    h="full"
                    w="100%"
                    color="white"
                    px={[8, 12, 16, null, null, 24]}
                    py={[12, null, null, 16, null, 24]}
                    maxW={['xl', null, null, 'lg', 'xl', '3xl']}
                    justifySelf={['center', null, null, 'start']}
                >
                    <DiLogo
                        variant="horizontalRGBWhite"
                        width={[56, null, null, null, 64, 72]}
                        mb={[8, null, null, 20]}
                    />
                    <Heading
                        color="white"
                        fontSize={['3xl', null, '4xl', '5xl', '6xl', '7xl']}
                        mb={[4, null, null, null, null, 8]}
                    >
                        {header}
                    </Heading>
                    <Text fontSize={['lg', null, 'xl', null, 'xl', '2xl']} opacity={0.9}>
                        {description}
                    </Text>
                </Flex>
            </SimpleGrid>
            <Center
                flexGrow={[1, null, null, 0]}
                minH="100%"
                w="100%"
                bgColor={['white', '#f5f5f5']}
                alignItems={['start', 'center']}
            >
                <Container maxW="xl" bgColor="white" py={[8, 12]} px={[8, 12, 16]}>
                    {children}
                </Container>
            </Center>
        </Flex>
    );
}
